/**
 * スライダーを手動でスワイプした時に目次の色を変える
 * @param {Number} index 中央に持ってきたいスライドのインデックス
 * @param {Array} listItems 目次のリスト
 * @param {} splide インスタンス化したsplide
 */

export const updateActiveListItem = (index, listItems) => {
  // 他のリストアイテムのアクティブクラスを削除
  listItems.forEach((item) => item.classList.remove('is-active'));

  // クリックされたリストアイテムにアクティブクラスを追加
  listItems[index].classList.add('is-active');
};
